import { Navigate, useParams } from 'react-router-dom';
import { getEnvConfig } from '@configs/env';
import { Loader } from '@components/loader';
import { useGetCategories } from '@queryHooks/useCategory';
import { Products } from '../products/Products';
import { useProviderStoreContext } from './ProviderStoreContext';

/**
 * 판매자 스토어 카테고리별 상품 목록
 * ProductsInCategory와 동일하지만 providerDomain을 Products에 전달
 */
export const ProviderStoreProductsInCategory = () => {
  const { name, providerDomain } = useParams<{ name: string; providerDomain: string }>();
  const decodedName = decodeURIComponent(name ?? '');
  const { providerId } = useProviderStoreContext();
  const { data: rootCategories, isSuccess } = useGetCategories({ isRootCategory: true, providerId });
  const { CUSTOM_ROOT_CATEGORY } = getEnvConfig();
  const supportsCustomCategory = CUSTOM_ROOT_CATEGORY?.toLowerCase() === 'true';

  // 카테고리가 지정되지 않는 경우, 기본 카테고리 상품 표시
  if (!decodedName) {
    if (!isSuccess) return <Loader />;

    return (
      <Navigate
        to={
          supportsCustomCategory && rootCategories?.content?.[0]
            ? `category/${encodeURIComponent(rootCategories?.content?.[0].name)}`
            : 'category/Software'
        }
        replace
      />
    );
  }

  return <Products type={decodedName} key={decodedName} providerDomain={providerDomain} providerId={providerId} />;
};
